import React, { useEffect, useState } from 'react'
import bike from '../../Assets/Images/hatchback_683088.png';
import { GoArrowLeft } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { Card, Modal } from 'react-bootstrap';
import CarKyc from './CarKyc';
import NomineeDetails from './NomineeDetails';
import NewCarPolicyDetailRegistration from './NewCarPolicyDetailRegistration';
import axios from 'axios';
import apiUrls from '../../Api/MainApi';
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Loader from '../../Layout/Loader/Loader';

function CarPolicyDetails() {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [policyNumber, setPolicyNumber] = useState('')
    const [applicationId, setApplicationID] = useState('')
    const [vahaanData, setVahaanData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [quotationResponse, setQuotationResponse] = useState({
        idv: null,
        totalTax: null,
        netPremium: null,
        insuranceName: "",
        image: null
    })
    const [isNextDisabled, setIsNextDisabled] = useState(true)
    const [personalInfoError, setPersonalInfoError] = useState(true)
    const [formTitles, setFormTitles] = useState(["KYC Details", "Personal Details", "Nominee Details"]);
    const [formData, setFormData] = useState({
        FirstName: null,
        ExpiryDate: null,
        LastName: null,
        Country: null,
        pincode: null,
        pincodeName: null,  // to capture the name of the pincode
        City: null,
        cityName: null,  // to capture the name of the city
        AddressType: null,
        District: null,
        State: null,
        stateName: null, // to capture the name of the state 
        Gender: null,
        DateOfBirth: null,
        PersonType: null,
        addressDocType: null,
        CKYCReferenceNumber: null,
        IsKYCDone: null,
        CKYCReferenceDocID: null,
        Photo: null,
        IDVerificationDocType: null,
        identificationDocumentId: null,
        issuingPlace: null,
        documentType: null,
        documentId: null,
        issueDate: null,
        isVehicleOwner: null,
        isInsuredPerson: null,
        isPolicyHolder: null,
        isDriver: null,
        nomineeFirstName: null,
        nomineeLastName: null,
        nomineeDateOfBirth: null,
        nomineeMiddleName: null,
        nomineePersonType: null,
        nomineeRelation: null,
        selfInspection: false,
        furtherAgreement: null,
        financer: null,
        MobilecommunicationId: null,
        MobileisPrefferedCommunication: null,
        MobilecommunicationType: null,
        EmailcommunicationId: null,
        EmailisPrefferedCommunication: null,
        EmailcommunicationType: null,
        engineNumber: null,
        chassisNumber: null,
        vehicleIDV: null,
        vehicleMaincode: null,
        policyHolderType: null,
        flatNo: null,
        StreetNo: null,
        nomineeRelationID: null,
        previousPolicyNumber: null,
    })
    const [lgShow, setLgShow] = useState(false); // for modal from react bootstrap
    useEffect(() => {
        const proVahaanData = async () => {
            const Rdata = JSON.parse(sessionStorage.getItem('CarDetails'))

            try {
                const response = await axios.post(apiUrls.VahanProPlus, { Consent: "Y", RegistrationNo: Rdata.registrationNUmber, VehicleCategory: "LMV" })
                const data = response.data.data
                setVahaanData(data)
                setFormData(prev => ({
                    ...prev,
                    engineNumber: data.engineNumber,
                    chassisNumber: data.chassisNumber,
                    previousPolicyNumber: data.policyNumber
                }))
                console.log(data, "line 96")
            }
            catch (error) {
                console.error(error);
            }
        }
        proVahaanData()
    }, [])

    useEffect(() => { //  to get lead details
        const LeadId = sessionStorage.getItem('CarLeadID')
        const fetchData = async () => {
            if (LeadId) {
                const leadResponse = await axios.post(apiUrls.GetLeadMasterByID, { Id: LeadId })
                const leadData = leadResponse.data.data
                console.log(leadData)
                const customerName = leadData.customerName || '';
                const [FName, ...rest] = customerName.split(' ');
                const LName = rest.join(' ');

                setFormData(prev => ({
                    ...prev,
                    FirstName: FName || '',
                    LastName: LName || '',
                    EmailcommunicationId: leadData.emailID,
                    MobilecommunicationId: leadData.mobileNo
                }));
            }
        }
        fetchData()
    }, [])
    useEffect(() => {
        const data = JSON.parse(sessionStorage.getItem('quotationResponse'))
        setQuotationResponse(prev => ({
            insuranceName: data.insuranceName,
            image: data.image,
            netPremium: data.netPremium,
            idv: data.idv,
            totalTax: data.totalTax
        }))
    }, [])
    useEffect(() => {
        console.log(formData, "line 121 form proposal form")
    }, [formData])
    useEffect(() => {
        if (page === 0 && formData.CKYCReferenceNumber && formData.DateOfBirth) {
            setIsNextDisabled(false);
        }
        else if (page === 1 && !personalInfoError && formData.State && formData.City && formData.pincode && formData.engineNumber && formData.chassisNumber) {
            // alert("hello")
            setIsNextDisabled(false);
        } else if (page === 2 && formData.nomineeDateOfBirth && formData.nomineeFirstName && formData.nomineeLastName) {
            setIsNextDisabled(false);
        }
        else {
            setIsNextDisabled(true); // Disable next button if none of the conditions are met
        }
    }, [formData, page, personalInfoError]);
    const PageDisplay = () => {
        if (page === 0) {
            return <CarKyc
                formData={formData}
                setFormData={setFormData}
            />;
        } else if (page === 1) {
            return <NewCarPolicyDetailRegistration
                formData={formData}
                setFormData={setFormData}
                setPersonalInfoError={setPersonalInfoError}
            />;
        } else if (page === 2) {
            return <NomineeDetails
                formData={formData}
                setFormData={setFormData}
            />;
        }
    };
    function previousClick() {
        navigate(`${process.env.PUBLIC_URL}/motor-insurance/car-policy-list`)
    }
    const handleNextButtonClick = () => {
        if (isNextDisabled === true) {
            toast.error('Please enter the valid data.', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            setPage((currPage) => currPage + 1);
        }
    };
    const CarDetails = JSON.parse(sessionStorage.getItem('CarDetails'))
    const CarQuotationRequest = JSON.parse(sessionStorage.getItem('CarQuotationRequest'))

    // Function to handle previous button click
    const handlePrevButtonClick = () => {
        setPage((currPage) => currPage - 1);
    };
    const handleSubmit = async () => {
        if (isNextDisabled === true) {
            toast.error('Please enter the valid data.', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            // alert("hello"); // This alert is showing, so the else part is executing
            console.log("submit");
            const assetsRequest = {
                vehicleType: "Car",
                registrationNumber: CarQuotationRequest.licensePlateNumber ? CarQuotationRequest.licensePlateNumber : null,
                year: CarQuotationRequest.manufactureDate,
                policyExpiryDate: CarQuotationRequest.previousPolicyExpiryDate ? CarQuotationRequest.previousPolicyExpiryDate : null,
                make: CarQuotationRequest.MakeID,
                model: CarQuotationRequest.ModelID,
                variant: CarQuotationRequest.VariantID
            }
            const proposalRequest = {
                InsurerID: CarQuotationRequest.InsurerID,
                MakeID: CarQuotationRequest.MakeID,
                ModelID: CarQuotationRequest.ModelID,
                NCBID: CarQuotationRequest.NCBID,
                VariantID: CarQuotationRequest.VariantID,
                FirstName: formData.FirstName,
                ExpiryDate: null,
                LastName: formData.LastName,
                Country: "IN",
                PincodeID: formData.pincode,  // to change it later
                pincodeName: formData.pincodeName,
                CityID: formData.City,  // to change it later
                cityName: formData.cityName,
                AddressType: "PRIMARY_RESIDENCE",
                FlatNumber: formData.flatNo,
                Street: formData.StreetNo,
                District: "",
                StateID: formData.State,
                stateName: formData.stateName,
                Gender: "MALE",  // imp
                GenderID: 11,
                DateOfBirth: formData.DateOfBirth,
                PersonType: formData.PersonType,
                AddressDocType: "",
                CKYCReferenceNumber: formData.CKYCReferenceNumber,
                IsKYCDone: "false",
                CKYCReferenceDocID: "D07",
                Photo: "null",
                IDVerificationDocType: "",
                identificationDocumentId: "",
                issuingPlace: "",
                documentType: "",
                documentId: "",
                issueDate: "",
                isVehicleOwner: "true",
                isInsuredPerson: "",
                isPolicyHolder: "",
                isDriver: "",
                nomineeFirstName: formData.nomineeFirstName,
                nomineeLastName: formData.nomineeLastName,
                nomineeDateOfBirth: formData.DateOfBirth,
                nomineeMiddleName: "",
                nomineePersonType: "INDIVIDUAL",
                nomineeRelation: "",
                selfInspection: false,
                furtherAgreement: "",
                financer: "",
                MobilecommunicationId: formData.MobilecommunicationId,
                MobileisPrefferedCommunication: "true",
                MobilecommunicationType: "",
                EmailcommunicationId: formData.EmailcommunicationId,
                EmailisPrefferedCommunication: "true",
                EmailcommunicationType: "",
                enquiryId: CarQuotationRequest.enquiryId,
                isPOSP: false,
                engineNumber: formData.engineNumber,
                isVehicleNew: CarQuotationRequest.isVehicleNew,
                licensePlateNumber: CarQuotationRequest.licensePlateNumber,
                manufactureDate: CarQuotationRequest.manufactureDate,
                registrationAuthority: CarDetails.rto,
                registrationDate: CarQuotationRequest.registrationDate,
                vehicleIdentificationNumber: formData.chassisNumber,
                vehicleIDV: null,
                vehicleMaincode: "",
                previousPolicyExpiryDate: CarQuotationRequest.previousPolicyExpiryDate ? CarQuotationRequest.previousPolicyExpiryDate : "null",
                isClaimInLastYear: CarQuotationRequest.isClaimInLastYear,
                previousInsurerCode: CarQuotationRequest.previousInsurerCode,
                previousPolicyNumber: formData.previousPolicyNumber, // vahaan se
                currentThirdPartyPolicy: null,
                isPreviousInsurerKnown: CarQuotationRequest.isPreviousInsurerKnown,
                previousPolicyType: null,  // session mai se
                previousNoClaimBonus: "ZERO", //  session se 
                originalPreviousPolicyType: null, // set
                policyHolderType: formData.policyHolderType,
                insuranceProductCode: "", /// session
                endDate: CarQuotationRequest.endDate, // session
                externalPolicyNumber: null,
                subInsuranceProductCode: null,
                nomineeRelationID: formData.nomineeRelationID,
                VehicleType: "Car",
                InsurerProductID: CarQuotationRequest.InsurerProductID,
                previousPolicyTypeID: CarQuotationRequest.PreviousPolicyTypeID,
                successReturnURL: apiUrls.returnUrlKyc,
                failureReturnURL: apiUrls.returnUrlKyc,
                startDate: CarQuotationRequest.startDate,// session
                PreviousPolicyTypeID: CarQuotationRequest.PreviousPolicyTypeID,
                currentThirdPartyPolicyStartDateTime: CarQuotationRequest.currentThirdPartyPolicyStartDateTime,
                currentThirdPartyPolicyExpiryDateTime: CarQuotationRequest.currentThirdPartyPolicyExpiryDateTime,
                currentThirdPartyPolicyNumber: formData.previousPolicyNumber,
                PreviousInsurerID: CarQuotationRequest.PreviousInsurerID,
                BusinessTypeName: CarQuotationRequest.BusinessTypeName,
                AssetDetails: JSON.stringify(assetsRequest),
                IsNomineeDetails: true,
                IsFamilyDetails: true,
                IsPolicyDetails: true,
                IsKYCDetails: true,
                IsAssetDetails: true,
                ProductName:"Motor",
                /// addon /// 
                cngSelection: false,
                consumablesSelection: false,
                engineProtectionSelection: false,
                keyAndLockProtectSelection: false,
                partsDepreciationSelection: false,
                personalBelongingSelection: false,
                returnToInvoiceSelection: false,
                rimProtectionSelection: false,
                roadSideAssistanceSelection: false,
                //accessories
                tyreProtectionSelection: false,
                electricalSelection: false,
                nonElectricalSelection: false,
                // legal liabilities
                cleanersLLSelection: false,
                employeesLLSelection: false,
                nonFarePaxLLSelection: false,
                paidDriverLLSelection: false,
                unnamedPaxLLSelection: false,
                workersCompensationLLSelection: false,
                // unNamed Pa
                unnamedCleanerSelection: false,
                unnamedConductorSelection: false,
                unnamedHirerSelection: false,
                unnamedPaidDriverSelection: false,
                unnamedPaxSelection: false,
                unnamedPillionRiderSelection: false,
            }
            console.log(proposalRequest, "line 265")
            setLoading(true)
            const proposaleResponse = await axios.post(apiUrls.CreateProposal, proposalRequest);
            console.log(proposaleResponse);
            if (proposaleResponse.data.status === 0) {
                sessionStorage.setItem("MotorReviewData", JSON.stringify(proposalRequest));
                setLoading(false)
                // Swal.fire({ 
                //     title: "Success",
                //     text: "Create Proposal API is working",
                //     icon: "success"
                // });
                const { policyNumber, applicationId, grossPremium } = proposaleResponse.data.data;
                setPolicyNumber(policyNumber);
                setApplicationID(applicationId);
                if (policyNumber) {
                    const policyData = {        // to store in sessionStorage
                        policyNumber: policyNumber,
                        applicationId: applicationId,
                        vehicleType: "Car"
                    }
                    sessionStorage.setItem("MotorPolicyData", JSON.stringify(policyData));
                    console.log(policyNumber, "line 287")
                    console.log(applicationId, "line 288")

                    ///////////////////////////////////////////////////////////////////////
                    try {                                  //////// api for kyc 
                        const kycStatusResponse = await axios.post(apiUrls.CheckKYCStatus, {
                            InsurerID: CarQuotationRequest.InsurerID,
                            PolicyNumber: policyNumber
                        });
                        const kycStatusData = kycStatusResponse.data;
                        if (kycStatusData.status === 0) {
                            console.log(kycStatusData.data, "line 295")
                            const kycMessage = kycStatusData.data.kycVerificationStatus === "DONE"
                                ? "KYC is created"
                                : "KYC is not done";

                            Swal.fire({
                                title: "Success",
                                text: kycMessage,
                                icon: kycStatusData.data.kycVerificationStatus === "DONE" ? "success" : "error"
                            });
                            if (kycStatusData.data.kycVerificationStatus === "DONE") {
                                navigate(`${process.env.PUBLIC_URL}/motor-insurance/review`)
                            } else {
                                if (kycStatusData.data.link) {
                                    console.log(kycStatusData.data.link, "link")
                                    window.location.href = kycStatusData.data.link;
                                }
                            }
                        } else {
                            Swal.fire({
                                title: "Error",
                                text: "KYC status check failed",
                                icon: "error"
                            });
                        }
                    } catch (kycError) {
                        Swal.fire({
                            title: "Error",
                            text: "Failed to check KYC status",
                            icon: "error"
                        });
                    }

                }
                else {
                    Swal.fire({
                        title: "Error",
                        text: "policy number not found",
                        icon: "error"
                    });
                }
            } else {
                setLoading(false)
                Swal.fire({
                    title: "Error",
                    text: "Your Proposal Details has been saved",
                    icon: "error"
                });
            }
        }
    }
    return (
        <>
            <>
                <div className='container mt-5 mb-5'>
                    <div className='row policy-detail-page'>
                        <div className='col-8'>
                            <p className='previous-page' onClick={previousClick}> <GoArrowLeft /> Back</p>
                            <div className='wrapper-inner'>
                                <div className='details-company-logo'>
                                    <img src={quotationResponse.image} alt='logo' />
                                </div>
                                <div className='plan-details-name plans-flex-div'>
                                    <div>
                                        <h6>{quotationResponse.insuranceName}</h6>
                                        <span style={{ cursor: 'pointer' }} onClick={() => setLgShow(true)} >View all features</span>
                                    </div>
                                </div>
                            </div>
                            <Modal
                                size="lg"
                                show={lgShow}
                                centered
                                onHide={() => setLgShow(false)}
                                aria-labelledby="example-modal-sizes-title-lg"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="example-modal-sizes-title-lg">
                                        Large Modal
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>...</Modal.Body>
                            </Modal>
                            {/* <div className='inner_right_section mt-4'> */}
                            <Card className='inner_right_section mt-4 pb-5 '>
                                <Card.Title>
                                    <div className="header text-center mt-3">
                                        {!loading && <h4>{formTitles[page]}</h4>}
                                        {/* <p>{FormPara[page]}</p> */}
                                    </div>
                                </Card.Title>
                                <Card.Body>
                                    {loading && <Loader />}
                                    {!loading && PageDisplay()}
                                </Card.Body>
                                <div className='d-flex justify-content-center gap-5' style={{position:"relative"}}>
                                    {
                                        page > 0 && (
                                            <>
                                                {!loading && (
                                                    <button
                                                        className='posp-back-button'
                                                        onClick={handlePrevButtonClick}
                                                    >
                                                        <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1024 1024"><path d="M874.690416 495.52477c0 11.2973-9.168824 20.466124-20.466124 20.466124l-604.773963 0 188.083679 188.083679c7.992021 7.992021 7.992021 20.947078 0 28.939099-4.001127 3.990894-9.240455 5.996574-14.46955 5.996574-5.239328 0-10.478655-1.995447-14.479783-5.996574l-223.00912-223.00912c-3.837398-3.837398-5.996574-9.046027-5.996574-14.46955 0-5.433756 2.159176-10.632151 5.996574-14.46955l223.019353-223.029586c7.992021-7.992021 20.957311-7.992021 28.949332 0 7.992021 8.002254 7.992021 20.957311 0 28.949332l-188.073446 188.073446 604.753497 0C865.521592 475.058646 874.690416 484.217237 874.690416 495.52477z"></path></svg>
                                                        <span style={{ color: 'black' }}>Back</span>
                                                    </button>
                                                )}

                                            </>
                                        )
                                    }
                                    {page === formTitles.length - 1 ? (
                                        <>
                                            {!loading && (
                                                <button className='btn btn-success' onClick={handleSubmit}>Review & Pay</button>
                                            )}
                                        </>
                                    ) : (
                                        <button type='button' className='posp-next-button' onClick={handleNextButtonClick}>
                                            <span style={{ color: '#fff' }}>Next</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></path>
                                            </svg>
                                        </button>
                                    )}
                                </div>
                            </Card>
                            {/* </div> */}
                        </div>
                        <div className='col-4'>
                            <div className='inner_right_section summary-section'>
                                <h6 className='summary-heading mt-2'>Summary</h6>
                                <div className='edit-vechile-detail '>
                                    <div className='bike-image-div mt-2'>
                                        <img className='bike-image' src={bike} alt="Bike"></img>
                                    </div>
                                    <div className="vehicleTxt">
                                        <em>Vehicle</em>
                                        <span>{CarDetails.makeLabel ? CarDetails.makeLabel : ""} {CarDetails.modelLabel ? CarDetails.modelLabel : ""}</span>
                                    </div>
                                </div>
                                <div className='info-div'>
                                    <span>Vehicle value (IDV) : </span>
                                    <span>₹  {quotationResponse.idv ? quotationResponse.idv : ""}</span>
                                </div>
                                <div className='info-div'>
                                    <span>NET PREMIUM : </span>
                                    <span>₹  {quotationResponse.netPremium ? quotationResponse.netPremium : ""}</span>
                                </div>
                                <div className='info-div'>
                                    <span>Total Tax</span>
                                    <span>₹ {quotationResponse.totalTax ? quotationResponse.totalTax : ""}</span>
                                </div>
                                <div className='payment-div'>
                                    <span>Total Premium</span>
                                    <span>₹ {Number(quotationResponse.netPremium) + Number(quotationResponse.totalTax)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </>
        </>
    )
}

export default CarPolicyDetails